__turbopack_context__.v({
  "RichText": "uBDWfq_RichText",
  "RichText--Center": "uBDWfq_RichText--Center",
  "RichText--Left": "uBDWfq_RichText--Left",
  "RichText--Manual": "uBDWfq_RichText--Manual",
  "RichText--Right": "uBDWfq_RichText--Right",
  "RichText__Container": "uBDWfq_RichText__Container",
});
